export function isImage(url:string) {
  const supportedExtensions = [".jpg", ".jpeg", ".png", ".gif", ".svg"];
  return supportedExtensions.some((ext) => url.toLowerCase().endsWith(ext));
}
